<h1 mat-dialog-title>API Key</h1>
<div mat-dialog-content>
  <p>This is the api key created. It cannot be displayed again.</p>

  <div fxLayout="row">
    <div fxFlex="90">
      <pre style="background-color: lightgray; padding: 4px; border: 1px solid gray">{{data.apiKeyPlain}}</pre>
    </div>
    <div fxFlex="10" style="text-align: right;">
      <button mat-icon-button (click)="copyKey()"><mat-icon>content_copy</mat-icon></button>
    </div>

  </div>

</div>
<div mat-dialog-actions align="end">
  <button type="button" mat-raised-button (click)="dialogRef.close()" cdkFocusInitial color="primary">Close</button>
</div>
